module.exports = __webpack_public_path__ + "img/giftcard-icon.191516ca.svg";